export const OPEN_UPGRADE_MODAL = "OPEN_UPGRADE_MODAL";
export const CLOSE_UPGRADE_MODAL = "CLOSE_UPGRADE_MODAL";

export const closeUpgradeModal = () => ({
  type: CLOSE_UPGRADE_MODAL,
});

export const openUpgradeModal = () => ({
  type: OPEN_UPGRADE_MODAL,
});
